import React, { Component } from 'react';
import SignIn from '../../components/developers/newsignin';
import { delete_cookie } from '../../utils/cookies';
// const enc = API.encrypt
export default class signIn extends Component {
  componentDidMount() {
    delete_cookie();
  }

  render() {
    return (
      <div id='SmartAPI-loader'>
        <SignIn />
      </div>
    );
  }
}
